/******************************************************************************************
 *	Market Segment Icon Directive
 *******************************************************************************************
 *
 * Converts a string (e.g. COMMERCIAL) to an <i> element with a CoralUI class (e.g. <i class="icon-shoppingcart"></i>).
 * The match is made using data in the MARKET_SEGMENTS constant.
 * In addition, If a show-icon-label="true" attribute is set, the element will also contain the label for icon (e.g. <i class="icon-shoppingcart">Commercial</i>).
 *
 */
(function() {
  

  angular.module('rcDirectives.marketSegmentIcon', []).directive(
    'marketSegmentIcon',
    /* @ngInject */
    function(MARKET_SEGMENTS) {
      return {
        restrict: 'AE',
        replace: true,
        scope: {
          rawMarketSegment: '@marketSegmentIcon'
        },
        templateUrl: 'templates/market-segment-icon.html',
        link: function(scope, element, attrs) {
          scope.showLabel = attrs.showIconLabel === 'true';

          scope.getMarketSegment = function() {
            if (scope.rawMarketSegment && MARKET_SEGMENTS[scope.rawMarketSegment]) {
              return MARKET_SEGMENTS[scope.rawMarketSegment];
            } else {
              return MARKET_SEGMENTS[MARKET_SEGMENTS.UNKNOWN];
            }
          };
        }
      };
    }
  );
})();
